module.exports = __webpack_public_path__ + "static/img/86_Easter_bunny.1eaee73c.jpg";